export const baseUrl =
  window.location.hostname === 'localhost' ? 'https://localhost:3000/' : 'https://jakobnohe.de/bilderbox/';
